import { Shield, Award, FileCheck, BadgeCheck } from 'lucide-react';
import type { ProviderCertificate } from '../types';

const TYPE_CONFIG: Record<string, { icon: typeof Shield; color: string; label: string }> = {
  license: { icon: FileCheck, color: 'bg-blue-50 text-blue-600', label: 'License' },
  accreditation: { icon: Award, color: 'bg-emerald-50 text-emerald-600', label: 'Accreditation' },
  certification: { icon: BadgeCheck, color: 'bg-purple-50 text-purple-600', label: 'Certification' },
  registration: { icon: Shield, color: 'bg-amber-50 text-amber-600', label: 'Registration' },
};

interface CertificatePanelProps {
  certificates: ProviderCertificate[];
}

export default function CertificatePanel({ certificates }: CertificatePanelProps) {
  if (certificates.length === 0) return null;

  return (
    <div className="card p-4">
      <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
        <Shield className="w-4 h-4 text-teal-600" />
        Certificates & Verification
      </h3>
      <div className="space-y-3">
        {certificates.map((cert, i) => {
          const config = TYPE_CONFIG[cert.type] || TYPE_CONFIG.certification;
          const Icon = config.icon;
          return (
            <div key={i} className="flex items-start gap-3 p-3 rounded-xl bg-gray-50">
              <div className={`w-9 h-9 rounded-lg ${config.color} flex items-center justify-center shrink-0`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-gray-900">{cert.name}</span>
                  <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${config.color}`}>{config.label}</span>
                </div>
                <p className="text-xs text-gray-500 mt-0.5">
                  Issued by {cert.issuedBy} &middot; {cert.year}
                </p>
                {cert.registrationNumber && (
                  <p className="text-xs text-gray-400 mt-0.5 font-mono">Reg: {cert.registrationNumber}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
